import React from 'react';
import { Hero } from '../components/Hero';
import { Navigation } from '../components/Navigation';
import { BookContent } from '../components/BookContent';
export const BookPage = () => {
  return <div className="min-h-screen bg-navy-950 text-cream-100 selection:bg-amber-500/30" data-id="element-387">
      <Navigation data-id="element-388" />

      <main className="lg:pl-72 w-full transition-all duration-300" data-id="element-389">
        <Hero data-id="element-390" />
        <BookContent data-id="element-391" />
      </main>

      {/* Lantern Glow Overlay (Fixed) */}
      <div className="fixed bottom-0 left-0 w-full h-32 bg-gradient-to-t from-navy-950 to-transparent pointer-events-none z-30 lg:hidden" data-id="element-392"></div>
    </div>;
};